import {
  Badge,
  Button,
  Card,
  Divider,
  List,
  Typography,
  notification,
  Empty,
  Spin,
} from "antd";
import { useEffect, useState } from "react";
import {
  PlusOutlined,
  EyeOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import bin_img from "../../../assets/dashboard/bin_img.png";
import { useLocation, useNavigate } from "react-router";
import ResponseMessage from "../Notification/ResponseMessge";
import ManageBinService from "../../../services/Dispatch-Centre-Service/ManageBinService";
import "../../../styles/global-ui.css";

const AddBulkScanGsm = ({ userData, title, type }) => {
  const [displayBin, setDisplayBin] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedBins, setSelectedBins] = useState([]);
  const [removeBtn, showRemoveBtn] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const [api, contextHolder] = notification.useNotification();
  const STORAGE_KEY = "bin_bulk_outward_inward_gsm";

  function openNotificationWithIcon(type, title, description) {
    api[type]({
      message: title,
      description,
      duration: 1,
    });
  }

  useEffect(() => {
    const fetchKanbanData = async () => {
      const queryParams = new URLSearchParams(location.search);
      const bin_id = queryParams.get("binId");

      if (!bin_id) {
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      try {
        const response = await ManageBinService.getBinDatabyBinId(bin_id);

        if (Array.isArray(response?.data) && response.data.length > 0) {
          const existingData =
            JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

          const combinedData = [...existingData, ...response.data];

          const uniqueBins = combinedData.filter(
            (bin, index, self) =>
              index === self.findIndex((b) => b.bin_id === bin.bin_id)
          );

          localStorage.setItem(STORAGE_KEY, JSON.stringify(uniqueBins));
          setDisplayBin(uniqueBins);
        } else {
          openNotificationWithIcon(
            "warning",
            "No Data Found",
            response?.message || "No Bin data available."
          );
        }
      } catch (error) {
        console.error(error);
        openNotificationWithIcon(
          "error",
          "Error",
          "An error occurred while fetching data."
        );
      } finally {
        setIsLoading(false);
      }
    };

    fetchKanbanData();
  }, [location]);

  useEffect(() => {
    try {
      const storedData = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      setDisplayBin(storedData);
    } catch (error) {
      console.error("Error fetching bin data:", error);
    }
  }, []);

  const handleBulkOutward = () => {
    navigate("/gsm-bulk-bin-inward/preview");
  };

  const handleSelectedBinOutward = () => {
    if (selectedBins.length === 0) {
      openNotificationWithIcon("warning", "Warning", "Bin is Not Selected");
      return;
    }

    try {
      const binBulkOutward =
        JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

      const updatedBinBulkOutward = binBulkOutward.filter(
        (bin) => !selectedBins.includes(bin.bin_id)
      );

      setDisplayBin(updatedBinBulkOutward);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedBinBulkOutward));

      setSelectedBins([]);
      showRemoveBtn(updatedBinBulkOutward.length > 0);

      ResponseMessage.success({ message: "Bin removed Successfully!" });
    } catch (error) {
      console.error("Error in handling selected bin outward:", error);
      setSelectedBins([]);
      ResponseMessage.error({
        message:
          "An error occurred while processing the bin outward operation. Please try again.",
      });
    }
  };

  const handleCardClick = (binId) => {
    setSelectedBins((prev) => {
      const newSelectedBins = prev.includes(binId)
        ? prev.filter((id) => id !== binId)
        : [...prev, binId];

      showRemoveBtn(newSelectedBins.length > 0);
      return newSelectedBins;
    });
  };

  return (
    <>
      {contextHolder}

      <Card
        className="modern-card"
        title={<Typography.Text strong>{title}</Typography.Text>}
        extra={
          <Button
            size="large"
            type="primary"
            className="primary-btn"
            icon={<PlusOutlined />}
            onClick={() => navigate("/gsm-bulk-bin-inward/scan")}
            disabled={isLoading}
          >
            Add Multiple Bin
          </Button>
        }
      >
        <div style={{ marginTop: 8 }}>
          {isLoading ? (
            <div className="dashboard-loading-wrap">
              <Spin size="large" />
            </div>
          ) : displayBin.length > 0 ? (
            <List
              grid={{
                gutter: 16,
                xs: 1,
                sm: 2,
                md: 3,
                lg: 4,
                xl: 5,
              }}
              dataSource={displayBin}
              renderItem={(bin) => (
                <List.Item>
                  <div
                    className="bin-card"
                    onClick={() => handleCardClick(bin.bin_id)}
                    style={{
                      borderColor: selectedBins.includes(bin.bin_id)
                        ? "#7c3aed"
                        : "#e2e8f0",
                    }}
                  >
                    <div className="bin-card-top">
                      <span
                        className="location-badge"
                        style={{
                          background: selectedBins.includes(bin.bin_id)
                            ? "#ede9fe"
                            : "#f1f5f9",
                          color: selectedBins.includes(bin.bin_id)
                            ? "#5b21b6"
                            : "#475569",
                          borderColor: selectedBins.includes(bin.bin_id)
                            ? "#c4b5fd"
                            : "#cbd5e1",
                        }}
                      >
                        {selectedBins.includes(bin.bin_id)
                          ? "Selected"
                          : "Tap to Select"}
                      </span>

                      <Badge
                        dot
                        offset={[-2, 6]}
                        color={
                          selectedBins.includes(bin.bin_id)
                            ? "#ef4444"
                            : "#cbd5e1"
                        }
                      />
                    </div>

                    <div className="bin-card-image-wrap">
                      <img src={bin_img} alt="Bin" className="bin-card-image" />
                      <div className="bin-card-name">
                        <strong>{bin.bin_name}</strong>
                      </div>
                    </div>

                    <div className="bin-card-footer">
                      <div
                        className={`pcs-badge ${
                          bin.bin_full === "yes" ? "full-badge" : "empty-badge"
                        }`}
                      >
                        {bin.total_quantity || 0} Pcs
                      </div>
                    </div>
                  </div>
                </List.Item>
              )}
            />
          ) : (
            <Empty description={`No bins found for ${title}`} />
          )}
        </div>
      </Card>

      {displayBin.length > 0 && !isLoading && (
        <div
          style={{
            position: "fixed",
            right: 24,
            bottom: 24,
            display: "flex",
            flexDirection: "column",
            gap: 12,
            zIndex: 1000,
          }}
        >
          {removeBtn && (
            <Button
              type="default"
              size="large"
              icon={<DeleteOutlined />}
              style={{
                minWidth: 220,
                boxShadow: "0 4px 16px rgba(15,23,42,0.12)",
                borderRadius: 10,
              }}
              onClick={handleSelectedBinOutward}
            >
              Remove Bin
            </Button>
          )}

          <Button
            type="primary"
            size="large"
            icon={<EyeOutlined />}
            className="primary-btn"
            style={{
              minWidth: 220,
              boxShadow: "0 4px 16px rgba(15,23,42,0.12)",
            }}
            onClick={handleBulkOutward}
          >
            Preview
          </Button>
        </div>
      )}
    </>
  );
};

export default AddBulkScanGsm;